var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 71,
    viewBox: "0 0 84 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 41.6667H8.33333V62.5H75V41.6667H83.3333V62.5C83.3333 67.125 79.625 70.8333 75 70.8333H8.33333C6.1232 70.8333 4.00358 69.9554 2.44078 68.3926C0.877973 66.8298 0 64.7101 0 62.5V41.6667ZM41.6667 0L18.5833 22.75L24.5 28.6667L37.5 15.625V54.1667H45.8333V15.625L58.875 28.6667L64.7917 22.7083L41.6667 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.c7dbe0e5800c6021710dad3e9bfbbc01.svg";
export { ForwardRef as ReactComponent };